import ApiService from './api';
import API_CONFIG, { getFullUrl } from '../config/apiConfig';

class ComplaintService {
  // Submit a new complaint
  // async submitComplaint(complaintData) {
  //   try {
  //     // Map frontend form data to backend expected format
  //     const backendData = {
  //       name: complaintData.name,
  //       mobile: complaintData.mobile,
  //       // email: complaintData.email,
  //       // address: complaintData.address,
  //       village: complaintData.village,
  //       categoryId: parseInt(complaintData.categoryId), // Ensure it's a number
  //       description: complaintData.description,
  //       taluka: complaintData.taluka || 'Gadchiroli',
  //       pincode: complaintData.pincode,
  //       dateOfBirth: complaintData.dob,
  //       gender: complaintData.gender?.toUpperCase()
  //     };

  //     return await ApiService.post('/complaints', backendData);
  //   } catch (error) {
  //     throw error;
  //   }
  // }

  // Track complaint by ID
  async trackComplaint(complaintId,lang='en') {
    try {
      return await ApiService.get(`/complaints/track/${complaintId}/${lang}`);
    } catch (error) {
      throw error;
    }
  }

  async submitRating({ complaintId, rating, comment }) {
    try {
      return await ApiService.post(`/complaints/${complaintId}/rating`, {
        rating,
        comment,
      });
    } catch (error) {
      throw error;
    }
  }

  async getComments(complaintId) {
    try {
      return await ApiService.get(`/complaints/${complaintId}/comments`);
    } catch (error) {
      throw error;
    }
  }

  async addComment(complaintId, commentData) {
    try {
      const token = localStorage.getItem('token');
      if (!token) throw new Error('No auth token found');

      return await ApiService.post(
        `/complaints/${complaintId}/comments`,
        commentData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );
    } catch (error) {
      throw error;
    }
  }

  // Get rating for a complaint
  async getRating(complaintId) {
    try {
      return await ApiService.get(`/complaints/${complaintId}/rating`);
    } catch (error) {
      throw error;
    }
  }

  // Track complaints by mobile number
  async trackComplaintByMobile(mobileNumber) {
    try {
      return await ApiService.get(`/complaints/track/mobile/${mobileNumber}`);
    } catch (error) {
      throw error;
    }
  }

  // Get all complaints (for officers/admin)
  async getComplaints(
    filters = {},
    pagination = { page: 0, size: 10 },
    sort = { sortBy: 'createdAt', sortOrder: 'desc' }
  ) {
    try {
      const queryParams = new URLSearchParams();

      // Add filters to query params
      Object.keys(filters).forEach((key) => {
        if (filters[key] && filters[key] !== '') {
          queryParams.append(key, filters[key]);
        }
      });

      queryParams.append('page', pagination.page.toString());
      queryParams.append('size', pagination.size.toString());

      queryParams.append('sortBy', sort.sortBy);
      queryParams.append('sortOrder', sort.sortOrder);

      const endpoint = `/complaints?${queryParams.toString()}`;
      return await ApiService.get(endpoint);
    } catch (error) {
      throw error;
    }
  }

  async getAttachmentImage(attachmentId) {
    try {
      // Backend serves at /api/files/attachments/{id}/image
      const blob = await ApiService.getBlob(
        `/files/attachments/${attachmentId}/image`
      );
      return blob;
    } catch (error) {
      throw error;
    }
  }

  // Update complaint status
  async updateComplaintStatus(complaintId, status, notes) {
    try {
      return await ApiService.put(`/complaints/${complaintId}/status`, {
        status,
        notes,
      });
    } catch (error) {
      throw error;
    }
  }

  // Reopen a resolved complaint (citizen action)
  async reopenComplaint(complaintId, { reason, phoneNumber }) {
    try {
      return await ApiService.post(`/complaints/${complaintId}/reopen`, {
        reason,
        phoneNumber,
      });
    } catch (error) {
      throw error;
    }
  }

  async getHeaderDashStats() {
    try {
      const token = localStorage.getItem('token');

      if (!token) throw new Error('No auth token found');

      return await ApiService.get('/dashboard/user-stats', {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      throw error;
    }
  }

  async getStats(filters = {},
    sort = { sortBy: 'createdAt', sortOrder: 'desc' }) {
    try {
      const queryParams = new URLSearchParams();

      // Add filters to query params
      Object.keys(filters).forEach((key) => {
        if (filters[key] && filters[key] !== '') {
          queryParams.append(key, filters[key]);
        }
      });
      queryParams.append('sortBy', sort.sortBy);
      queryParams.append('sortOrder', sort.sortOrder);
      const endpoint = `/complaints/stats?${queryParams.toString()}`;
      return await ApiService.get(endpoint);
    } catch (error) {
      throw error;
    }
  }


  // Get complaint statistics for dashboard
  async getComplaintStats() {
    try {
      const token = localStorage.getItem('token');

      if (!token) throw new Error('No auth token found');

      return await ApiService.get('/admin/analytics/dashboard', {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      throw error;
    }
  }
  // Assign complaint to officer
  async assignComplaint(complaintId, assignData) {
    try {
      return await ApiService.put(
        `/complaints/${complaintId}/assign`,
        assignData
      );
    } catch (error) {
      throw error;
    }
  }

  // Upload complaint attachment
  async uploadAttachment(complaintId, file) {
    try {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('complaintId', complaintId);

      return await ApiService.uploadFile('/files/upload', formData);
    } catch (error) {
      throw error;
    }
  }

  // Get complaint statistics for dashboard
  async getComplaintStats() {
    try {
      return await ApiService.get('/admin/analytics/dashboard');
    } catch (error) {
      throw error;
    }
  }

  async getAverageTat() {
    try {
      const token = localStorage.getItem('token');
      if (!token) throw new Error('No auth token found');

      return await ApiService.get('/analytics/average-tat', {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      throw error;
    }
  }

  // Get public complaint statistics for homepage
  async getPublicStats() {
    try {
      return await ApiService.get('/complaints/stats/public');
    } catch (error) {
      // Return mock data if API fails for demo purposes
      console.warn('Public stats API not available, returning mock data');
      return {
        success: true,
        data: {
          registered: 1245,
          resolved: 987,
          pending: 258,
        },
      };
    }
  }
  async getAttachmentImage(attachmentId) {
    try {
      const blob = await ApiService.getBlob(
        `/files/attachments/${attachmentId}/image`
      );
      return URL.createObjectURL(blob); // convert blob → usable URL
    } catch (error) {
      throw error;
    }
  }

  // Get complaints by officer
  async getOfficerComplaints(page = 0, size = 10, filters = {}) {
    try {
      const queryParams = new URLSearchParams({
        page,
        size,
        ...filters,
      });

      return await ApiService.get(
        `/complaints/officer?${queryParams.toString()}`
      );
    } catch (error) {
      throw error;
    }
  }

  // Search complaints
  async searchComplaints(searchTerm, filters = {}) {
    try {
      const queryParams = new URLSearchParams({
        search: searchTerm,
        ...filters,
      });

      return await ApiService.get(
        `/complaints/search?${queryParams.toString()}`
      );
    } catch (error) {
      throw error;
    }
  }

  // Generate PDF report
  async generateComplaintsReport(filters) {
    try {
      const token = localStorage.getItem('token');
      if (!token) throw new Error('No auth token found');

      const response = await fetch(getFullUrl('/reports/complaints/pdf'), {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
          Accept: '*/*',
        },
        body: JSON.stringify(filters),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      // Convert response to blob
      const blob = await response.blob();

      // Generate filename with date and time
      const now = new Date();
      const timestamp = now.toISOString().replace(/[:.]/g, '-').slice(0, 19);

      // Create descriptive filename based on filters
      let filename = `complaints-report-${timestamp}`;
      if (filters.fromDate && filters.toDate) {
        filename = `complaints-${filters.fromDate}-to-${filters.toDate}-${timestamp}`;
      }
      filename += '.pdf';

      // Create a temporary link to download the PDF file
      const fileURL = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = fileURL;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.remove();

      // Clean up the object URL to free memory
      window.URL.revokeObjectURL(fileURL);

      return true;
    } catch (error) {
      console.error('Error generating complaints report:', error);
      throw error;
    }
  }

  //convert to excel
  async generateComplaintsExcel(filters) {
    try {
      const token = localStorage.getItem('token');
      if (!token) throw new Error('No auth token found');

      const response = await fetch(getFullUrl('/reports/complaints/excel'), {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
          Accept: '*/*',
        },
        body: JSON.stringify(filters),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      // Convert response to blob
      const blob = await response.blob();

      // Generate filename with date and time
      const now = new Date();
      const timestamp = now.toISOString().replace(/[:.]/g, '-').slice(0, 19);

      // Create descriptive filename based on filters
      let filename = `complaints-report-${timestamp}`;
      if (filters.fromDate && filters.toDate) {
        filename = `complaints-${filters.fromDate}-to-${filters.toDate}-${timestamp}`;
      }
      filename += '.xlsx';

      // Create a temporary link to download the Excel file
      const fileURL = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = fileURL;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.remove();

      // Clean up the object URL to free memory
      window.URL.revokeObjectURL(fileURL);

      return true;
    } catch (error) {
      console.error('Error generating complaints Excel:', error);
      throw error;
    }
  }
  //assign complaint
  // Assign complaint locally using fetch
  async assignComplaint(complaintId, assignData) {
    try {
      const token = localStorage.getItem('token'); // if your API requires auth
      if (!token) {
        throw new Error('No auth token found');
      }

      const url = getFullUrl(`/complaints/${complaintId}/assign`);

      const response = await fetch(url, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(assignData),
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Error ${response.status}: ${errorText}`);
      }

      const result = await response.json();
   
      return result;
    } catch (error) {
      console.error('Failed to assign complaint:', error);
      throw error;
    }
  }

  async getOfficers() {
    try {
      return await ApiService.get('/admin/officers');
    } catch (error) {
      throw error;
    }
  }

  async getOfficers() {
    try {
      const token = localStorage.getItem('token');


      if (!token) throw new Error('No auth token found');

      const response = await ApiService.get('/admin/officers', {
        headers: { Authorization: `Bearer ${token}` },
      });

      return response;
    } catch (error) {
      console.error('Error fetching officers:', error);
      throw error;
    }
  }
  // //  dashboard state
  // async getComplaintStats() {
  //   try {
  //     return await ApiService.get('/dashboard/stats');
  //   } catch (error) {
  //     throw error;
  //   }
  // }

  // Get complaint statistics for dashboard

  async getDashboardStats() {
    try {
      return await ApiService.get('/dashboard/stats');
    } catch (error) {
      throw error;
    }
  }
  async getDashboardStats() {
    try {
      const token = localStorage.getItem('token');

      if (!token) throw new Error('No auth token found');

      return await ApiService.get('/dashboard/stats', {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      throw error;
    }
  }
}

const complaintServiceInstance = new ComplaintService();
export default complaintServiceInstance;
